import { Action } from 'redux';

import { IncrementRouterSpaceReactKey } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface IncrementRouterSpaceReactKeyAction extends Action {}

export function incrementRouterSpaceReactKey(): IncrementRouterSpaceReactKeyAction {
  return {
    type: IncrementRouterSpaceReactKey
  };
}
export const isIncrementRouterSpaceReactKeyAction
  = isActionFactory<IncrementRouterSpaceReactKeyAction>(IncrementRouterSpaceReactKey);
